export const getContrastColorFrom = (backgroundColor: string) => {
  if (/^#[a-f\d]{6}/gi.test(backgroundColor)) {
    return parseInt(backgroundColor.replace('#', ''), 16) > 0xffffff / 1.5 ? '#000' : '#fff';
  }
  console.warn(`${backgroundColor} received as a theme`);
  console.warn('Theme colors should be passed as an hexadecimal format, using #ffffff as a text color fallback.');
  return '#ffffff';
};
